<script>
  import { slide } from "svelte/transition";

  export var type = "default";
  export var icon = null;
</script>

<style type="text/less">
  .alert {
    --alert-color: var(--col-gray-50);

    border-radius: var(--border-radius);
    border: solid 1px var(--alert-color);
    color: var(--alert-color);
    display: flex;
    align-items: center;
  }

  .alert-icon {
    display: flex;
    align-items: center;
    align-self: stretch;
    flex: 0 1 auto;
    padding: var(--spacing-sm);
    background: var(--alert-color);
    color: var(--col-gray-100);
    font-size: 1.5rem;
    line-height: var(--line-height);
  }

  .alert-message {
    padding: var(--spacing-sm);
    width: 100%;

    &:empty {
      display: none;
    }
  }

  .alert-danger {
    --alert-color: var(--col-danger);
  }
  .alert-warning {
    --alert-color: var(--col-warning);
  }
  .alert-success {
    --alert-color: var(--col-success-d);
  }
  .alert-accent-1 {
    --alert-color: var(--col-accent-1);
  }
  .alert-accent-2 {
    --alert-color: var(--col-accent-2);
  }
</style>

<div id="alert" class={'alert alert-' + type} transition:slide|local>
  {#if icon}
    <div class="alert-icon">
      <svg class="icon">
        <use href="/icons.svg#{icon}" />
      </svg>
    </div>
  {/if}

  <div class="alert-message">
    <slot />
  </div>
</div>
